'use client'

import HouseBaseMarker from '../base'
export default function ForRentMarker({
  data,
  textZoom,
  onClick,
  active = false,
  onAdded,
  onPopupLoaded,
  onPopupLeave
}) {

  return (
    <HouseBaseMarker
      data={data}
      textZoom={textZoom}
      onClick={onClick}
      active={active}
      onAdded={onAdded}
      onPopupLoaded={onPopupLoaded}
      onPopupLeave={onPopupLeave}
      className='bg-purple'
      isRent
    ></HouseBaseMarker>
  )
}
